<template>

    <div  style="width: 100vw;" >
        <div >
            <slot name="page4" >
                <div >
                    <el-row >
                        <el-col   >
                            <div >
                                <el-row>
                                    <el-col >
                                        <div style=";font-weight: bold;font-size: 28px;text-align: center">{{list[0]}}</div>
                                    </el-col>
                                    <el-col >
                                        <div style="text-align: center">
                                            <hr class="hrLine" style="width:40px;"/> <i style="font-style: normal;color: #db261d;font-weight: bold">News</i>  <hr class="hrLine" style="width:40px;"/>
                                        </div>

                                    </el-col>

                                </el-row>
                            </div>
                        </el-col>



                        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"   :offset="3" style="padding: 50px 0">

                            <el-row :gutter="50" :class="{moveUp:pageAnimation}" id="newsView" style="opacity: 0" v-show="isPC">
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" v-for="(item,index) in news" :key="index" :index="index">
                                    <div style="border: 2px solid #ffffff;cursor: pointer;padding: 10px;height: 400px;overflow: hidden" >
                                        <ul style="height: 100%;" @click="moreNewsMethod(index)">
                                            <li style="height: 70%"><img :src="item.image" alt="" style="width: 100%;height: 100%;object-fit: cover;"></li>
                                            <li style="line-height: 1.5em;color: #409eff;padding-top: 20px">{{item.addTime}}</li>
                                            <li style="line-height: 1.5em;">{{item.title}}</li>
                                            <li style="padding: 10px 0;text-align: right;color: #409eff;font-size: 14px"><a @click="moreNewsMethod(index)"> 了解详情 <i class="el-icon-arrow-right"></i></a></li>
                                        </ul>
                                    </div>
                                </el-col>


                            </el-row>


                            <el-row :gutter="50" :class="{moveUp:pageAnimation}" id="newsView2" style="opacity: 0" v-show="!isPC">
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" >

                                    <el-carousel height="400px" indicator-position="none" loop="false">
                                        <el-carousel-item v-for="(item,index) in news" :key="index" :index="index" >
                                            <div style="border: 2px solid #ffffff;cursor: pointer;padding: 10px;height: 400px;overflow: hidden" >
                                                <ul style="height: 100%;" @click="moreNewsMethod(index)">
                                                    <li style="height: 70%"><img :src="item.image" alt="" style="width: 100%;height: 100%;object-fit: cover;"></li>
                                                    <li style="line-height: 1.5em;color: #409eff;padding-top: 20px">{{item.addTime}}</li>
                                                    <li style="line-height: 1.5em;">{{item.title}}</li>
                                                    <li style="padding: 10px 0;text-align: right;color: #409eff;font-size: 14px"><a @click="moreNewsMethod(index)"> Details <i class="el-icon-arrow-right"></i></a></li>
                                                </ul>
                                            </div>
                                        </el-carousel-item>
                                    </el-carousel>






                                </el-col>


                            </el-row>

                        </el-col>

                    </el-row>
                    <!--                    <MyFoot />-->
                    <foot @changeMsg="changes"  v-show="foot"  style="margin-top: 50px"></foot>
                </div>
            </slot>

        </div>

    </div>

    <el-dialog
            v-model="dialogVisible"
            :width=widths
            title="DOWNLOAD"
    >
        <div>
            <ul style="padding: 20px 0">

                <li style="overflow: hidden;border-bottom:1px solid #E8E8E8;padding: 10px 0" v-for="(i,index) in download" :key="index" :index="index">

                    <div style="width: 78%;float: left">
                        <p style="display: inline-block;font-size: 16px;color: black;line-height: 16px;">{{i.title}}</p><br/>
                        <p style="display: inline-block;font-size: 14px;line-height: 14px;">{{i.content}}</p>

                    </div>
                    <div style="line-height: 30px;width: 20%;float: right;margin-right: 3px">
                        <span v-show="i.downloadLink !=''"><a class="el-button-primary" :href="i.downloadLink">DOWNLOAD</a></span>
                    </div>

                </li>



            </ul>
        </div>

    </el-dialog>
</template>

<script>
    import Foot from "../components/Foot";
    import request from "@/utils/request";
    export default {
        name: "Page4",
        props:["page4Animation"],
        components: {
            Foot
        },
        data() {
            return {
                // list:["公司新闻",'联系我们','微信'],
                list:[],
                news:[1,2,3],
                newsID:[31,22,30],
                moreNews:'',
                isPC:false,
                Click1:true,
                Click2:false,
                dialogVisible: false,
                widths:'50%',
                download:[],
                foot:true,
                enter:false,
                pageAnimation:false


            }
        },



        methods: {


            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            moreNewsMethod(index){
                //获取新闻id号码，然后去数据库中根据id查询



                this.$router.push({path:"/NewsDescription",query:{describe:this.news[index].content}})


            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            changes(data){
                this.dialogVisible=data;
                request.get("/download/en").then(res =>{
                    this.download = res.data;


                }).catch((res)=>{
                })
            },
            isInViewPortOfTwo(){
                let that=this
                let target = document.getElementById("newsView");



                const observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        that.enter=true


                    } else {

                        // that.page3Animation=false
                        // .log('元素不在可视范围内');
                    }
                }, { threshold: 0.3 }); // 阈值设置为0.1，表示元素进入可视范围10%时触发回调函数
                observer.observe(target); // 开始监听元素


                let target2 = document.getElementById("newsView2");



                const observer2 = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        that.enter=true


                    } else {

                        // that.page3Animation=false
                        // .log('元素不在可视范围内');
                    }
                }, { threshold: 0.3 }); // 阈值设置为0.1，表示元素进入可视范围10%时触发回调函数
                observer.observe(target2); // 开始监听元素

            },
            scrolling(){
                this.isInViewPortOfTwo()
            },
            DestroyListener() {
                window.removeEventListener('scroll', this.scrolling);
            },
        },
        beforeMount(){
            if (this._isMobile()) {
                this.isPC=false;

            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;

            }
            request.get("/home/page4/en").then(res =>{
                this.list = res.data;


            }).catch((res)=>{
            })

            request.get("/company/1/3/en").then(res =>{

                this.news = res.data.data;
                this.moreNews=this.news[0].content

            }).catch((res)=>{
            })

            if (this.$route.params.key=="true"){

                this.changes(this.$route.params.key)
            }


        },
        mounted() {
            window.addEventListener("scroll", this.scrolling);

        },

        watch:{
            enter:{
                handler(news,old){
                    if (news==true){
                        this.pageAnimation=true

                    }

                }
            }
        }


    }
</script>

<style lang="less" scoped>

    .hrLine{
        vertical-align:middle; display:inline-block;
    }
    img{
        transition: transform 0.25s ease;
    }
    img:hover{
        transform: scale(1.1);
    }
    *{
        font-family: HarmonyOS_Sans_SC_Medium;
    }
</style>